export const resetSearch = () => {
  return {
    type: 'SEARCH_RESET',
  };
};
